var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          otherParams: {
            isDealerId: _vm.navSwitch,
            startDate: _vm.startDate,
            endDate: _vm.endDate,
          },
          columns: _vm.columns,
          "checkbox-config": _vm.checkboxConfig,
          "toolbar-config": _vm.toolbarConfig,
          "print-config": _vm.printConfig,
          "export-config": _vm.exportConfig,
          cellClick: _vm.chooseRow,
          cellDbClick: _vm.updateRow,
        },
        on: {
          "toolbar-addData": _vm.addRow,
          "toolbar-delData": function ($event) {
            return _vm.delRow()
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "VIEW",
                          expression: "`VIEW`",
                        },
                      ],
                      staticClass: "top_btns_box",
                      staticStyle: { display: "flex" },
                    },
                    [
                      _c("div", { staticClass: "status_box" }, [
                        _c(
                          "span",
                          {
                            staticClass: "status_item",
                            class: !_vm.navSwitch ? "active" : "",
                            on: {
                              click: function ($event) {
                                return _vm.changeNav(0)
                              },
                            },
                          },
                          [_vm._v("区域线索池")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "status_item",
                            class: _vm.navSwitch ? "active" : "",
                            on: {
                              click: function ($event) {
                                return _vm.changeNav(1)
                              },
                            },
                          },
                          [_vm._v("经销商线索池")]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "btns_box" },
                        [
                          [
                            "厂家主管副总",
                            "厂家部长",
                            "厂家员工",
                            "系统管理员",
                          ].includes(_vm.role)
                            ? _c(
                                "vxe-button",
                                {
                                  staticStyle: {
                                    border: "none",
                                    width: "100px",
                                  },
                                },
                                [
                                  _c(
                                    "a-upload",
                                    {
                                      attrs: {
                                        name: "file",
                                        multiple: false,
                                        accept: ".xlsx",
                                        action: _vm.api.clue.FactorImportUPLOAD,
                                        headers: { token: _vm.token },
                                      },
                                      on: { change: _vm.importHandleChange },
                                    },
                                    [_c("vxe-button", [_vm._v("厂家导入")])],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          [
                            "厂家主管副总",
                            "厂家部长",
                            "厂家员工",
                            "系统管理员",
                          ].includes(_vm.role)
                            ? _c(
                                "vxe-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.download(1)
                                    },
                                  },
                                },
                                [_vm._v("下载厂家导入模板 ")]
                              )
                            : _vm._e(),
                          _c(
                            "vxe-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "TRANSFER",
                                  expression: "`TRANSFER`",
                                },
                              ],
                              on: { click: _vm.showTransferPopFunc },
                            },
                            [_vm._v(" 转移 ")]
                          ),
                          [
                            "经销商总经理",
                            "经销商客户经理",
                            "经销商市场经理",
                            "经销商信息管理员",
                            "经销商客服专员",
                            "经销商销售顾问",
                          ].includes(_vm.role)
                            ? _c(
                                "vxe-button",
                                {
                                  staticStyle: {
                                    border: "none",
                                    width: "105px",
                                  },
                                },
                                [
                                  _c(
                                    "a-upload",
                                    {
                                      attrs: {
                                        name: "file",
                                        multiple: false,
                                        accept: ".xlsx",
                                        action: _vm.api.clue.DealerImportUPLOAD,
                                        headers: { token: _vm.token },
                                      },
                                      on: { change: _vm.importHandleChange },
                                    },
                                    [_c("vxe-button", [_vm._v("经销商导入")])],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          [
                            "经销商总经理",
                            "经销商客户经理",
                            "经销商市场经理",
                            "经销商信息管理员",
                            "经销商客服专员",
                            "经销商销售顾问",
                          ].includes(_vm.role)
                            ? _c(
                                "vxe-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.download(2)
                                    },
                                  },
                                },
                                [_vm._v("下载经销商导入模板 ")]
                              )
                            : _vm._e(),
                          _vm.navSwitch
                            ? _c(
                                "vxe-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "DISTRIBUTE",
                                      expression: "`DISTRIBUTE`",
                                    },
                                  ],
                                  on: { click: _vm.showAssignPopFunc },
                                },
                                [_vm._v(" 分配 ")]
                              )
                            : _vm._e(),
                          _vm.navSwitch
                            ? _c(
                                "a-popconfirm",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "BACK",
                                      expression: "`BACK`",
                                    },
                                  ],
                                  attrs: {
                                    title: "确定退回线索公海？",
                                    "ok-text": "确定",
                                    "cancel-text": "取消",
                                  },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.backToSea(null)
                                    },
                                  },
                                },
                                [_c("vxe-button", [_vm._v(" 退回公海 ")])],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "vxe-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "RECEIVE",
                                  expression: "`RECEIVE`",
                                },
                              ],
                              on: { click: _vm.receiveFunc },
                            },
                            [_vm._v("领取")]
                          ),
                          _c("vxe-button", { on: { click: _vm.delRow } }, [
                            _vm._v("删除"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "operate",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "vxe-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: row.isReceive === 0,
                          expression: "row.isReceive === 0",
                        },
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "RECEIVE",
                          expression: "`RECEIVE`",
                        },
                      ],
                      staticStyle: { "margin-right": "10px" },
                      attrs: { size: "mini", status: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.receiveFunc(row)
                        },
                      },
                    },
                    [_vm._v(" 领取 ")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "DISTRIBUTE",
                          expression: "`DISTRIBUTE`",
                        },
                      ],
                      staticStyle: { "margin-right": "10px" },
                      attrs: { size: "mini", status: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.showAssignPopFunc(row)
                        },
                      },
                    },
                    [_vm._v("分配 ")]
                  ),
                  _c(
                    "vxe-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "TRANSFER",
                          expression: "`TRANSFER`",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.navSwitch,
                          expression: "!navSwitch",
                        },
                      ],
                      staticStyle: { "margin-right": "10px" },
                      attrs: { size: "mini", status: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.showTransferPopFunc(row)
                        },
                      },
                    },
                    [_vm._v("转移 ")]
                  ),
                  _c(
                    "a-popconfirm",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "BACK",
                          expression: "`BACK`",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.navSwitch,
                          expression: "navSwitch",
                        },
                      ],
                      attrs: {
                        title: "确定退回线索公海？",
                        "ok-text": "确定",
                        "cancel-text": "取消",
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.backToSea(row)
                        },
                      },
                    },
                    [
                      _c(
                        "vxe-button",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { size: "mini", status: "primary" },
                        },
                        [_vm._v(" 退回公海 ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "formModal",
        {
          attrs: {
            title: "线索池详情",
            centered: "",
            closable: false,
            footer: null,
            maskClosable: false,
            visible: _vm.detailPage,
            width: 1200,
          },
        },
        [
          _vm.detailPage
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
                on: {
                  cancelled: function ($event) {
                    return _vm.closeEdit()
                  },
                  saved: function ($event) {
                    return _vm.closeEdit(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择分配人",
            centered: "",
            closable: true,
            footer: null,
            maskClosable: true,
            width: 1200,
          },
          model: {
            value: _vm.showAssignPop,
            callback: function ($$v) {
              _vm.showAssignPop = $$v
            },
            expression: "showAssignPop",
          },
        },
        [
          _vm.showAssignPop
            ? _c("sonDeptUsersList", {
                ref: "sonDeptUsersList",
                attrs: { assignIdArr: _vm.assignIdArr },
                on: { close: _vm.closePop },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择经理部",
            centered: "",
            footer: null,
            maskClosable: true,
            width: 1200,
            closable: true,
          },
          model: {
            value: _vm.showTransferPop,
            callback: function ($$v) {
              _vm.showTransferPop = $$v
            },
            expression: "showTransferPop",
          },
        },
        [
          _vm.showTransferPop
            ? _c("sonDealerList", {
                ref: "sonDealerList",
                attrs: { transferIdArr: _vm.transferIdArr },
                on: { close: _vm.closeTransferPop },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("loading"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }